export const QUIZZES = {
  "understanding-market": {
    id: "understanding-market-quiz",
    lessonId: "understanding-market",
    title: "Understanding the Market Quiz",
    description:
      "Check your understanding of market participants, price movement, and trading opportunity.",
    passingScore: 70,
    questions: [
      {
        id: "market-question-1",
        question:
          "What most directly causes a stock price to move?",
        correctAnswer: "b",
        answers: [
          {
            id: "a",
            label: "A",
            text: "The company logo changes",
          },
          {
            id: "b",
            label: "B",
            text:
              "The balance between buyers and sellers changes",
          },
          {
            id: "c",
            label: "C",
            text: "The market clock reaches noon",
          },
          {
            id: "d",
            label: "D",
            text: "Every stock follows the same direction",
          },
        ],
      },
      {
        id: "market-question-2",
        question:
          "Why should a trader wait for confirmation before entering?",
        correctAnswer: "c",
        answers: [
          {
            id: "a",
            label: "A",
            text: "To guarantee that every trade wins",
          },
          {
            id: "b",
            label: "B",
            text: "To avoid using a stop loss",
          },
          {
            id: "c",
            label: "C",
            text:
              "To reduce the chance of reacting to a false move",
          },
          {
            id: "d",
            label: "D",
            text: "To make the stock move faster",
          },
        ],
      },
      {
        id: "market-question-3",
        question:
          "Which group can participate in the stock market?",
        correctAnswer: "d",
        answers: [
          {
            id: "a",
            label: "A",
            text: "Only banks",
          },
          {
            id: "b",
            label: "B",
            text: "Only professional traders",
          },
          {
            id: "c",
            label: "C",
            text: "Only company employees",
          },
          {
            id: "d",
            label: "D",
            text:
              "Institutions, traders, investors, and market makers",
          },
        ],
      },
    ],
  },

  "how-stocks-move": {
  id: "how-stocks-move-quiz",
  lessonId: "how-stocks-move",
  title: "How Stocks Move Quiz",
  description:
    "Check your understanding of buying pressure, selling pressure, volume, liquidity, and catalysts.",
  passingScore: 75,
  questions: [
    {
      id: "how-stocks-move-question-1",
      question:
        "What can push a stock price higher?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Buyers refusing to trade at any price",
        },
        {
          id: "b",
          label: "B",
          text:
            "Buyers repeatedly accepting higher asking prices",
        },
        {
          id: "c",
          label: "C",
          text:
            "The market clock moving forward",
        },
        {
          id: "d",
          label: "D",
          text:
            "Every seller leaving the market permanently",
        },
      ],
    },
    {
      id: "how-stocks-move-question-2",
      question:
        "What can push a stock price lower?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Buyers increasing every bid",
        },
        {
          id: "b",
          label: "B",
          text:
            "The company changing its ticker symbol",
        },
        {
          id: "c",
          label: "C",
          text:
            "Sellers repeatedly accepting lower bids",
        },
        {
          id: "d",
          label: "D",
          text:
            "The spread becoming invisible",
        },
      ],
    },
    {
      id: "how-stocks-move-question-3",
      question:
        "Why can a low-liquidity stock move quickly?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Fewer shares may be available near the current price",
        },
        {
          id: "b",
          label: "B",
          text:
            "Low liquidity guarantees a safe trade",
        },
        {
          id: "c",
          label: "C",
          text:
            "The stock cannot move downward",
        },
        {
          id: "d",
          label: "D",
          text:
            "Volume no longer matters",
        },
      ],
    },
    {
      id: "how-stocks-move-question-4",
      question:
        "Which combination gives stronger support to a price move?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "No catalyst, weak volume, and a wide spread",
        },
        {
          id: "b",
          label: "B",
          text:
            "One fast candle with no follow-through",
        },
        {
          id: "c",
          label: "C",
          text:
            "A rumor with declining participation",
        },
        {
          id: "d",
          label: "D",
          text:
            "Meaningful news, stronger volume, and continued buying demand",
        },
      ],
    },
  ],
},

"market-orders": {
  id: "market-orders-quiz",
  lessonId: "market-orders",
  title: "Market Orders and Limit Orders Quiz",
  description:
    "Check your understanding of execution speed, price control, slippage, spreads, and fill risk.",
  passingScore: 75,
  questions: [
    {
      id: "market-orders-question-1",
      question:
        "What is the main priority of a market order?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Guaranteeing an exact execution price",
        },
        {
          id: "b",
          label: "B",
          text:
            "Executing as quickly as possible at the best available price",
        },
        {
          id: "c",
          label: "C",
          text:
            "Waiting until the spread disappears",
        },
        {
          id: "d",
          label: "D",
          text:
            "Preventing the stock from moving",
        },
      ],
    },
    {
      id: "market-orders-question-2",
      question:
        "What is the main advantage of a limit order?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "It guarantees the order will fill",
        },
        {
          id: "b",
          label: "B",
          text:
            "It removes all market risk",
        },
        {
          id: "c",
          label: "C",
          text:
            "It gives the trader control over the maximum buying price or minimum selling price",
        },
        {
          id: "d",
          label: "D",
          text:
            "It always fills faster than a market order",
        },
      ],
    },
    {
      id: "market-orders-question-3",
      question:
        "Why might a market order fill at a different price than expected?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Available prices can change while the order is being executed",
        },
        {
          id: "b",
          label: "B",
          text:
            "Market orders are never sent to an exchange",
        },
        {
          id: "c",
          label: "C",
          text:
            "The displayed quote is always delayed by one day",
        },
        {
          id: "d",
          label: "D",
          text:
            "Limit orders automatically replace market orders",
        },
      ],
    },
    {
      id: "market-orders-question-4",
      question:
        "What is a possible disadvantage of a limit order?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "The order must always fill above the limit price",
        },
        {
          id: "b",
          label: "B",
          text:
            "The trader loses all control over price",
        },
        {
          id: "c",
          label: "C",
          text:
            "The order can only be used after market hours",
        },
        {
          id: "d",
          label: "D",
          text:
            "The order may not fill if the market does not reach the limit price",
        },
      ],
    },
  ],
},

"bid-ask-spread": {
  id: "bid-ask-spread-quiz",
  lessonId: "bid-ask-spread",
  title: "Bid, Ask, and Spread Quiz",
  description:
    "Check your understanding of bids, asks, spreads, liquidity, and execution quality.",
  passingScore: 75,
  questions: [
    {
      id: "bid-ask-question-1",
      question:
        "What does the bid represent?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "The lowest price a seller will accept",
        },
        {
          id: "b",
          label: "B",
          text:
            "The highest price a buyer is currently willing to pay",
        },
        {
          id: "c",
          label: "C",
          text:
            "The last price from the previous trading day",
        },
        {
          id: "d",
          label: "D",
          text:
            "The stock’s guaranteed execution price",
        },
      ],
    },
    {
      id: "bid-ask-question-2",
      question:
        "What does the ask represent?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "The highest price a buyer is offering",
        },
        {
          id: "b",
          label: "B",
          text:
            "The average price of all trades",
        },
        {
          id: "c",
          label: "C",
          text:
            "The lowest price a seller is currently willing to accept",
        },
        {
          id: "d",
          label: "D",
          text:
            "The stock’s daily low",
        },
      ],
    },
    {
      id: "bid-ask-question-3",
      question:
        "A stock has a bid of $5.00 and an ask of $5.08. What is the spread?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text: "$0.08",
        },
        {
          id: "b",
          label: "B",
          text: "$0.05",
        },
        {
          id: "c",
          label: "C",
          text: "$0.13",
        },
        {
          id: "d",
          label: "D",
          text: "$5.04",
        },
      ],
    },
    {
      id: "bid-ask-question-4",
      question:
        "Why can a wide spread increase trading risk?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "It guarantees a profitable entry",
        },
        {
          id: "b",
          label: "B",
          text:
            "It removes the need for a stop loss",
        },
        {
          id: "c",
          label: "C",
          text:
            "It means every order will fill instantly",
        },
        {
          id: "d",
          label: "D",
          text:
            "It creates more distance between the best buyer and seller, which can worsen execution",
        },
      ],
    },
  ],
},

"volume-liquidity": {
  id: "volume-liquidity-quiz",
  lessonId: "volume-liquidity",
  title: "Volume and Liquidity Quiz",
  description:
    "Check your understanding of trading activity, execution quality, spreads, slippage, and confirmation.",
  passingScore: 75,
  questions: [
    {
      id: "volume-liquidity-question-1",
      question:
        "What does trading volume measure?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "The guaranteed execution price",
        },
        {
          id: "b",
          label: "B",
          text:
            "How many shares are traded during a period",
        },
        {
          id: "c",
          label: "C",
          text:
            "The distance between support and resistance",
        },
        {
          id: "d",
          label: "D",
          text:
            "The number of market makers",
        },
      ],
    },
    {
      id: "volume-liquidity-question-2",
      question:
        "What does liquidity describe?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "How quickly a company reports earnings",
        },
        {
          id: "b",
          label: "B",
          text:
            "How often the market opens",
        },
        {
          id: "c",
          label: "C",
          text:
            "How easily shares can be bought or sold near the expected price",
        },
        {
          id: "d",
          label: "D",
          text:
            "How high a stock can rise",
        },
      ],
    },
    {
      id: "volume-liquidity-question-3",
      question:
        "Why can low liquidity increase trading risk?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "It can create wider spreads, greater slippage, and partial fills",
        },
        {
          id: "b",
          label: "B",
          text:
            "It guarantees a tighter spread",
        },
        {
          id: "c",
          label: "C",
          text:
            "It prevents price movement",
        },
        {
          id: "d",
          label: "D",
          text:
            "It guarantees every order fills at one price",
        },
      ],
    },
    {
      id: "volume-liquidity-question-4",
      question:
        "Why is stronger volume often important during a breakout?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "It guarantees the breakout cannot fail",
        },
        {
          id: "b",
          label: "B",
          text:
            "It removes the need for risk management",
        },
        {
          id: "c",
          label: "C",
          text:
            "It means the spread will always be zero",
        },
        {
          id: "d",
          label: "D",
          text:
            "It can show that more traders are participating in the move",
        },
      ],
    },
  ],
},

"relative-volume": {
  id: "relative-volume-quiz",
  lessonId: "relative-volume",
  title: "Relative Volume Quiz",
  description:
    "Check your understanding of normal versus unusual trading activity and how relative volume supports trade analysis.",
  passingScore: 75,
  questions: [
    {
      id: "relative-volume-question-1",
      question:
        "What does relative volume compare?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text: "The bid with the ask",
        },
        {
          id: "b",
          label: "B",
          text:
            "Current trading activity with typical activity for the same period",
        },
        {
          id: "c",
          label: "C",
          text: "The current price with yesterday’s close",
        },
        {
          id: "d",
          label: "D",
          text: "Support with resistance",
        },
      ],
    },
    {
      id: "relative-volume-question-2",
      question:
        "What does a relative-volume reading of 1.0 usually mean?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Volume is three times normal",
        },
        {
          id: "b",
          label: "B",
          text: "There is no trading activity",
        },
        {
          id: "c",
          label: "C",
          text: "Current activity is close to normal",
        },
        {
          id: "d",
          label: "D",
          text: "The stock must rise",
        },
      ],
    },
    {
      id: "relative-volume-question-3",
      question:
        "A stock normally trades 500,000 shares by 10:00 AM but has traded 1,500,000 shares today. What is its approximate relative volume?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text: "3.0",
        },
        {
          id: "b",
          label: "B",
          text: "1.0",
        },
        {
          id: "c",
          label: "C",
          text: "0.5",
        },
        {
          id: "d",
          label: "D",
          text: "5.0",
        },
      ],
    },
    {
      id: "relative-volume-question-4",
      question:
        "Why does high relative volume not guarantee that a stock will rise?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Because relative volume only works after market close",
        },
        {
          id: "b",
          label: "B",
          text: "Because it always measures selling only",
        },
        {
          id: "c",
          label: "C",
          text: "Because it removes all price movement",
        },
        {
          id: "d",
          label: "D",
          text:
            "Because unusually high activity can come from strong buying or strong selling",
        },
      ],
    },
  ],
},

"float-share-supply": {
  id: "float-share-supply-quiz",
  lessonId: "float-share-supply",
  title: "Float and Share Supply Quiz",
  description:
    "Check your understanding of public float, shares outstanding, volatility, volume, and low-float risk.",
  passingScore: 75,
  questions: [
    {
      id: "float-share-supply-question-1",
      question:
        "What does stock float generally measure?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "The company’s total annual revenue",
        },
        {
          id: "b",
          label: "B",
          text:
            "The shares generally available for public trading",
        },
        {
          id: "c",
          label: "C",
          text:
            "The highest price reached during the day",
        },
        {
          id: "d",
          label: "D",
          text:
            "The number of market makers",
        },
      ],
    },
    {
      id: "float-share-supply-question-2",
      question:
        "Why can a low-float stock move quickly?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Because the company guarantees a price increase",
        },
        {
          id: "b",
          label: "B",
          text:
            "Because low-float stocks have no sellers",
        },
        {
          id: "c",
          label: "C",
          text:
            "Because fewer tradable shares may be available to absorb buying or selling pressure",
        },
        {
          id: "d",
          label: "D",
          text:
            "Because every order fills at the same price",
        },
      ],
    },
    {
      id: "float-share-supply-question-3",
      question:
        "Which statement best describes the relationship between shares outstanding and float?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Float is usually only the portion of shares outstanding that is generally available for public trading",
        },
        {
          id: "b",
          label: "B",
          text:
            "They always mean exactly the same thing",
        },
        {
          id: "c",
          label: "C",
          text:
            "Float is always larger than shares outstanding",
        },
        {
          id: "d",
          label: "D",
          text:
            "Shares outstanding only includes intraday trades",
        },
      ],
    },
    {
      id: "float-share-supply-question-4",
      question:
        "Why should low-float stocks receive a higher risk rating?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "They cannot be halted",
        },
        {
          id: "b",
          label: "B",
          text:
            "They always have tight spreads",
        },
        {
          id: "c",
          label: "C",
          text:
            "They guarantee strong liquidity",
        },
        {
          id: "d",
          label: "D",
          text:
            "They can experience rapid price movement, wider spreads, slippage, and halt risk",
        },
      ],
    },
  ],
},

"volatility-price-range": {
  id: "volatility-price-range-quiz",
  lessonId: "volatility-price-range",
  title: "Volatility and Price Range Quiz",
  description:
    "Check your understanding of price movement, range, stop placement, position size, and volatility risk.",
  passingScore: 75,
  questions: [
    {
      id: "volatility-question-1",
      question:
        "What does volatility describe?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text: "The company’s total number of employees",
        },
        {
          id: "b",
          label: "B",
          text: "How quickly and how far a stock’s price moves",
        },
        {
          id: "c",
          label: "C",
          text: "The guaranteed direction of the next candle",
        },
        {
          id: "d",
          label: "D",
          text: "The number of exchanges trading the stock",
        },
      ],
    },
    {
      id: "volatility-question-2",
      question:
        "How is a price range calculated?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Open minus close",
        },
        {
          id: "b",
          label: "B",
          text: "Bid plus ask",
        },
        {
          id: "c",
          label: "C",
          text: "High minus low",
        },
        {
          id: "d",
          label: "D",
          text: "Volume divided by float",
        },
      ],
    },
    {
      id: "volatility-question-3",
      question:
        "Why may a highly volatile stock require a smaller position size?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Because larger price swings can create more dollar risk per share",
        },
        {
          id: "b",
          label: "B",
          text:
            "Because volatile stocks cannot be sold",
        },
        {
          id: "c",
          label: "C",
          text:
            "Because volatility guarantees a losing trade",
        },
        {
          id: "d",
          label: "D",
          text:
            "Because the spread is always zero",
        },
      ],
    },
    {
      id: "volatility-question-4",
      question:
        "Which risk adjustment is most appropriate for a faster-moving stock?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Use more shares and ignore the stop",
        },
        {
          id: "b",
          label: "B",
          text:
            "Assume the move will continue",
        },
        {
          id: "c",
          label: "C",
          text:
            "Use the same stop and share size for every stock",
        },
        {
          id: "d",
          label: "D",
          text:
            "Use a structure-based stop and reduce share size when needed",
        },
      ],
    },
  ],
},

"average-true-range": {
  id: "average-true-range-quiz",
  lessonId: "average-true-range",
  title: "Average True Range Quiz",
  description:
    "Check your understanding of ATR, volatility, stop planning, targets, and position sizing.",
  passingScore: 75,
  questions: [
    {
      id: "average-true-range-question-1",
      question:
        "What does ATR primarily measure?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text: "The guaranteed direction of the next move",
        },
        {
          id: "b",
          label: "B",
          text: "The typical amount a stock moves during a selected period",
        },
        {
          id: "c",
          label: "C",
          text: "The number of shares outstanding",
        },
        {
          id: "d",
          label: "D",
          text: "The company’s earnings growth",
        },
      ],
    },
    {
      id: "average-true-range-question-2",
      question:
        "What does a higher ATR usually indicate?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text: "The stock must rise",
        },
        {
          id: "b",
          label: "B",
          text: "The spread is always tighter",
        },
        {
          id: "c",
          label: "C",
          text: "The stock has recently experienced larger price movement",
        },
        {
          id: "d",
          label: "D",
          text: "The stock has no risk",
        },
      ],
    },
    {
      id: "average-true-range-question-3",
      question:
        "Why does ATR not predict whether price will rise or fall?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Because it measures movement size, not direction",
        },
        {
          id: "b",
          label: "B",
          text: "Because ATR only works after market close",
        },
        {
          id: "c",
          label: "C",
          text: "Because ATR ignores all price movement",
        },
        {
          id: "d",
          label: "D",
          text: "Because ATR is the same for every stock",
        },
      ],
    },
    {
      id: "average-true-range-question-4",
      question:
        "How can ATR help with risk management?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text: "It guarantees the correct entry",
        },
        {
          id: "b",
          label: "B",
          text: "It removes the need for a stop loss",
        },
        {
          id: "c",
          label: "C",
          text: "It guarantees the target will be reached",
        },
        {
          id: "d",
          label: "D",
          text:
            "It can help judge stop distance, target realism, and appropriate position size",
        },
      ],
    },
  ],
},

"risk-reward-ratio": {
  id: "risk-reward-ratio-quiz",
  lessonId: "risk-reward-ratio",
  title: "Risk-to-Reward Ratio Quiz",
  description:
    "Check your understanding of planned risk, potential reward, entry, stop, target, and setup quality.",
  passingScore: 75,
  questions: [
    {
      id: "risk-reward-question-1",
      question:
        "For a long trade, how is risk per share usually calculated?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Target price minus entry price",
        },
        {
          id: "b",
          label: "B",
          text: "Entry price minus stop price",
        },
        {
          id: "c",
          label: "C",
          text: "Ask price minus bid price",
        },
        {
          id: "d",
          label: "D",
          text: "Volume divided by float",
        },
      ],
    },
    {
      id: "risk-reward-question-2",
      question:
        "For a long trade, how is potential reward per share usually calculated?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Stop price minus entry price",
        },
        {
          id: "b",
          label: "B",
          text: "Entry price minus target price",
        },
        {
          id: "c",
          label: "C",
          text: "Target price minus entry price",
        },
        {
          id: "d",
          label: "D",
          text: "High price minus low price",
        },
      ],
    },
    {
      id: "risk-reward-question-3",
      question:
        "An entry is $5.20, the stop is $5.10, and the target is $5.40. What is the risk-to-reward ratio?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text: "1-to-2",
        },
        {
          id: "b",
          label: "B",
          text: "2-to-1",
        },
        {
          id: "c",
          label: "C",
          text: "1-to-1",
        },
        {
          id: "d",
          label: "D",
          text: "1-to-4",
        },
      ],
    },
    {
      id: "risk-reward-question-4",
      question:
        "Why is a favorable risk-to-reward ratio not enough by itself?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Because stops are never necessary",
        },
        {
          id: "b",
          label: "B",
          text: "Because every trade must use the same target",
        },
        {
          id: "c",
          label: "C",
          text: "Because the ratio guarantees the trade will fail",
        },
        {
          id: "d",
          label: "D",
          text:
            "Because the setup still needs confirmation, liquidity, and a realistic target",
        },
      ],
    },
  ],
},

"position-sizing": {
  id: "position-sizing-quiz",
  lessonId: "position-sizing",
  title: "Position Sizing Quiz",
  description:
    "Check your understanding of maximum dollar risk, stop distance, risk per share, and share calculation.",
  passingScore: 75,
  questions: [
    {
      id: "position-sizing-question-1",
      question:
        "What should a trader decide before calculating position size?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text: "The maximum number of shares available in the market",
        },
        {
          id: "b",
          label: "B",
          text: "The maximum dollar amount they are willing to risk",
        },
        {
          id: "c",
          label: "C",
          text: "The company’s annual revenue",
        },
        {
          id: "d",
          label: "D",
          text: "The stock’s all-time high",
        },
      ],
    },
    {
      id: "position-sizing-question-2",
      question:
        "For a long trade, how is risk per share usually calculated?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Target minus entry",
        },
        {
          id: "b",
          label: "B",
          text: "Ask minus bid",
        },
        {
          id: "c",
          label: "C",
          text: "Entry minus stop",
        },
        {
          id: "d",
          label: "D",
          text: "Volume divided by float",
        },
      ],
    },
    {
      id: "position-sizing-question-3",
      question:
        "A trader risks $50 with $0.10 of risk per share. What is the position size?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text: "500 shares",
        },
        {
          id: "b",
          label: "B",
          text: "50 shares",
        },
        {
          id: "c",
          label: "C",
          text: "5,000 shares",
        },
        {
          id: "d",
          label: "D",
          text: "100 shares",
        },
      ],
    },
    {
      id: "position-sizing-question-4",
      question:
        "What usually happens to position size when the stop distance becomes wider?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Position size should always increase",
        },
        {
          id: "b",
          label: "B",
          text: "Position size stays the same for every trade",
        },
        {
          id: "c",
          label: "C",
          text: "The stop is no longer needed",
        },
        {
          id: "d",
          label: "D",
          text: "Position size should decrease to keep dollar risk controlled",
        },
      ],
    },
  ],
},

"trade-planning": {
  id: "trade-planning-quiz",
  lessonId: "trade-planning",
  title: "Trade Planning Quiz",
  description:
    "Check your understanding of setup quality, confirmation, risk, position size, targets, and invalidation.",
  passingScore: 75,
  questions: [
    {
      id: "trade-planning-question-1",
      question:
        "What should a complete trade plan define before entry?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Only the stock symbol",
        },
        {
          id: "b",
          label: "B",
          text:
            "The setup, entry, stop, targets, position size, and invalidation level",
        },
        {
          id: "c",
          label: "C",
          text: "Only the potential profit",
        },
        {
          id: "d",
          label: "D",
          text: "The stock’s all-time high",
        },
      ],
    },
    {
      id: "trade-planning-question-2",
      question:
        "Why should risk be calculated before placing the order?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Because the stop can be removed afterward",
        },
        {
          id: "b",
          label: "B",
          text: "Because every trade should use the same share size",
        },
        {
          id: "c",
          label: "C",
          text:
            "Because the stop distance and maximum dollar risk determine position size",
        },
        {
          id: "d",
          label: "D",
          text: "Because risk guarantees the target will be reached",
        },
      ],
    },
    {
      id: "trade-planning-question-3",
      question:
        "What does the invalidation level represent?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "The price or condition showing that the original trade idea has failed",
        },
        {
          id: "b",
          label: "B",
          text: "The guaranteed profit price",
        },
        {
          id: "c",
          label: "C",
          text: "The highest possible position size",
        },
        {
          id: "d",
          label: "D",
          text: "The average daily volume",
        },
      ],
    },
    {
      id: "trade-planning-question-4",
      question:
        "What should happen when important parts of the trade plan are missing?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Enter immediately before price moves",
        },
        {
          id: "b",
          label: "B",
          text: "Increase the position size",
        },
        {
          id: "c",
          label: "C",
          text: "Ignore the stop and focus on the target",
        },
        {
          id: "d",
          label: "D",
          text:
            "Mark the plan incomplete and wait until the missing conditions are defined",
        },
      ],
    },
  ],
},

"entry-confirmation": {
  id: "entry-confirmation-quiz",
  lessonId: "entry-confirmation",
  title: "Entry Confirmation Quiz",
  description:
    "Check your understanding of setup quality, price confirmation, volume, momentum, liquidity, and market conditions.",
  passingScore: 75,
  questions: [
    {
      id: "entry-confirmation-question-1",
      question:
        "What is the difference between a setup and entry confirmation?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "There is no difference",
        },
        {
          id: "b",
          label: "B",
          text:
            "A setup creates interest, while confirmation provides evidence that the trade is developing",
        },
        {
          id: "c",
          label: "C",
          text:
            "Confirmation always happens before the setup",
        },
        {
          id: "d",
          label: "D",
          text:
            "A setup guarantees a profitable trade",
        },
      ],
    },
    {
      id: "entry-confirmation-question-2",
      question:
        "Which combination best supports a breakout entry?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Price approaches resistance with weak volume",
        },
        {
          id: "b",
          label: "B",
          text:
            "Price briefly touches resistance and immediately falls",
        },
        {
          id: "c",
          label: "C",
          text:
            "Price moves above resistance, holds the level, and volume increases",
        },
        {
          id: "d",
          label: "D",
          text:
            "The trader feels the stock may rise",
        },
      ],
    },
    {
      id: "entry-confirmation-question-3",
      question:
        "Which condition can make an entry too risky even when price appears to confirm?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "A wide spread, poor liquidity, or nearby resistance",
        },
        {
          id: "b",
          label: "B",
          text:
            "A clearly defined stop",
        },
        {
          id: "c",
          label: "C",
          text:
            "A realistic target",
        },
        {
          id: "d",
          label: "D",
          text:
            "A complete trade plan",
        },
      ],
    },
    {
      id: "entry-confirmation-question-4",
      question:
        "What should a trader do when confirmation is weak or incomplete?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Enter with a larger position",
        },
        {
          id: "b",
          label: "B",
          text:
            "Remove the stop",
        },
        {
          id: "c",
          label: "C",
          text:
            "Assume the setup will work",
        },
        {
          id: "d",
          label: "D",
          text:
            "Wait for stronger evidence or skip the trade",
        },
      ],
    },
  ],
},

"profit-targets": {
  id: "profit-targets-quiz",
  lessonId: "profit-targets",
  title: "Profit Targets Quiz",
  description:
    "Check your understanding of market structure, realistic targets, ATR, resistance, and partial profit planning.",
  passingScore: 75,
  questions: [
    {
      id: "profit-targets-question-1",
      question:
        "What should primarily guide a profit target?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Hope that the stock keeps rising",
        },
        {
          id: "b",
          label: "B",
          text:
            "Market structure such as resistance, prior highs, and realistic price levels",
        },
        {
          id: "c",
          label: "C",
          text: "The number of shares in the account",
        },
        {
          id: "d",
          label: "D",
          text: "The trader’s favorite dollar amount",
        },
      ],
    },
    {
      id: "profit-targets-question-2",
      question:
        "Why should volatility and ATR be considered when setting a target?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Because ATR guarantees the target will be reached",
        },
        {
          id: "b",
          label: "B",
          text: "Because volatility removes all risk",
        },
        {
          id: "c",
          label: "C",
          text:
            "Because they help show whether the planned target is realistic for the stock’s normal movement",
        },
        {
          id: "d",
          label: "D",
          text: "Because every stock has the same ATR",
        },
      ],
    },
    {
      id: "profit-targets-question-3",
      question:
        "What is one benefit of taking partial profits?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "It can lock in some gains while allowing part of the position to continue",
        },
        {
          id: "b",
          label: "B",
          text: "It guarantees the remaining shares will rise",
        },
        {
          id: "c",
          label: "C",
          text: "It removes the need for a stop",
        },
        {
          id: "d",
          label: "D",
          text: "It always produces the maximum possible profit",
        },
      ],
    },
    {
      id: "profit-targets-question-4",
      question:
        "What should happen when market conditions weaken before the target is reached?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text: "Ignore the weakness and keep the original plan no matter what",
        },
        {
          id: "b",
          label: "B",
          text: "Increase the position size",
        },
        {
          id: "c",
          label: "C",
          text: "Remove the stop",
        },
        {
          id: "d",
          label: "D",
          text:
            "Reassess the target and protect the trade if the original reward is no longer realistic",
        },
      ],
    },
  ],
},

"trailing-stops": {
  id: "trailing-stops-quiz",
  lessonId: "trailing-stops",
  title: "Trailing Stops Quiz",
  description:
    "Check your understanding of original stops, profit protection, higher lows, volatility, and stop placement.",
  passingScore: 75,
  questions: [
    {
      id: "trailing-stops-question-1",
      question:
        "What is the main purpose of a trailing stop?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text: "To guarantee the maximum possible profit",
        },
        {
          id: "b",
          label: "B",
          text:
            "To protect developing profit while allowing the trade room to continue",
        },
        {
          id: "c",
          label: "C",
          text: "To remove all normal price movement",
        },
        {
          id: "d",
          label: "D",
          text: "To increase the original trade risk",
        },
      ],
    },
    {
      id: "trailing-stops-question-2",
      question:
        "Which action is generally appropriate as a winning trade develops?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Move the stop farther away whenever price begins falling",
        },
        {
          id: "b",
          label: "B",
          text:
            "Remove the stop after the first target is reached",
        },
        {
          id: "c",
          label: "C",
          text:
            "Raise the stop below a new support level or higher low",
        },
        {
          id: "d",
          label: "D",
          text:
            "Move the stop above the current market price",
        },
      ],
    },
    {
      id: "trailing-stops-question-3",
      question:
        "Why can a trailing stop placed too close to price be a problem?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Normal volatility may trigger the stop before the trend continues",
        },
        {
          id: "b",
          label: "B",
          text:
            "It guarantees a larger loss",
        },
        {
          id: "c",
          label: "C",
          text:
            "It prevents the trader from taking partial profits",
        },
        {
          id: "d",
          label: "D",
          text:
            "It always increases liquidity",
        },
      ],
    },
    {
      id: "trailing-stops-question-4",
      question:
        "What should a trader generally avoid doing with the original stop?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Placing it near the setup invalidation level",
        },
        {
          id: "b",
          label: "B",
          text:
            "Planning it before entry",
        },
        {
          id: "c",
          label: "C",
          text:
            "Using it to define initial risk",
        },
        {
          id: "d",
          label: "D",
          text:
            "Moving it farther away to avoid accepting a planned loss",
        },
      ],
    },
  ],
},

"breakouts-false-breakouts": {
  id: "breakouts-false-breakouts-quiz",
  lessonId: "breakouts-false-breakouts",
  title: "Breakouts and False Breakouts Quiz",
  description:
    "Check your understanding of breakout confirmation, volume, follow-through, retests, and false-breakout warning signs.",
  passingScore: 75,
  questions: [
    {
      id: "breakouts-false-breakouts-question-1",
      question:
        "What is a false breakout?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Price holds above resistance and continues higher",
        },
        {
          id: "b",
          label: "B",
          text:
            "Price briefly crosses an important level and then quickly reverses",
        },
        {
          id: "c",
          label: "C",
          text:
            "Price remains inside a trading range",
        },
        {
          id: "d",
          label: "D",
          text:
            "Volume increases before the market opens",
        },
      ],
    },
    {
      id: "breakouts-false-breakouts-question-2",
      question:
        "Which behavior best supports a valid breakout?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Price briefly moves above resistance on weak volume and immediately falls",
        },
        {
          id: "b",
          label: "B",
          text:
            "The spread becomes wider while buyers disappear",
        },
        {
          id: "c",
          label: "C",
          text:
            "Price moves above resistance, holds the level, and receives stronger volume and follow-through",
        },
        {
          id: "d",
          label: "D",
          text:
            "The trader enters before price reaches resistance",
        },
      ],
    },
    {
      id: "breakouts-false-breakouts-question-3",
      question:
        "Why can waiting for a retest improve breakout confirmation?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "It can show whether the old resistance level is becoming support",
        },
        {
          id: "b",
          label: "B",
          text:
            "It guarantees that the stock cannot fall",
        },
        {
          id: "c",
          label: "C",
          text:
            "It removes the need for volume",
        },
        {
          id: "d",
          label: "D",
          text:
            "It guarantees the highest possible entry",
        },
      ],
    },
    {
      id: "breakouts-false-breakouts-question-4",
      question:
        "Which is a warning that a breakout may be failing?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Price holds above the level with increasing participation",
        },
        {
          id: "b",
          label: "B",
          text:
            "The breakout receives follow-through",
        },
        {
          id: "c",
          label: "C",
          text:
            "A pullback holds the former resistance level",
        },
        {
          id: "d",
          label: "D",
          text:
            "Price quickly falls back below the breakout level on weak participation",
        },
      ],
    },
  ],
},

"vwap-basics": {
  id: "vwap-basics-quiz",
  lessonId: "vwap-basics",
  title: "VWAP Basics Quiz",
  description:
    "Check your understanding of volume-weighted average price, intraday trend, support and resistance, and trade confirmation.",
  passingScore: 75,
  questions: [
    {
      id: "vwap-basics-question-1",
      question:
        "What does VWAP represent?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "The highest price reached during the session",
        },
        {
          id: "b",
          label: "B",
          text:
            "The session’s average traded price weighted by volume",
        },
        {
          id: "c",
          label: "C",
          text:
            "The average closing price from the previous week",
        },
        {
          id: "d",
          label: "D",
          text:
            "The total number of available shares",
        },
      ],
    },
    {
      id: "vwap-basics-question-2",
      question:
        "What may price holding above a rising VWAP suggest?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "The stock is guaranteed to rise",
        },
        {
          id: "b",
          label: "B",
          text:
            "Volume is no longer important",
        },
        {
          id: "c",
          label: "C",
          text:
            "Intraday demand may be stronger",
        },
        {
          id: "d",
          label: "D",
          text:
            "The spread must be zero",
        },
      ],
    },
    {
      id: "vwap-basics-question-3",
      question:
        "How can VWAP act during an intraday uptrend?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "It may act as dynamic support during pullbacks",
        },
        {
          id: "b",
          label: "B",
          text:
            "It guarantees that every pullback will reverse",
        },
        {
          id: "c",
          label: "C",
          text:
            "It removes the need for a stop loss",
        },
        {
          id: "d",
          label: "D",
          text:
            "It always becomes the day’s high",
        },
      ],
    },
    {
      id: "vwap-basics-question-4",
      question:
        "What is the best way to use VWAP?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Enter every time price touches the line",
        },
        {
          id: "b",
          label: "B",
          text:
            "Use it as a guaranteed buy or sell signal",
        },
        {
          id: "c",
          label: "C",
          text:
            "Ignore price action and volume",
        },
        {
          id: "d",
          label: "D",
          text:
            "Combine it with price action, volume, market structure, and risk management",
        },
      ],
    },
  ],
},

"level-2-basics": {
  id: "level-2-basics-quiz",
  lessonId: "level-2-basics",
  title: "Level 2 Basics Quiz",
  description:
    "Check your understanding of bids, asks, market depth, liquidity, order changes, and displayed buying or selling pressure.",
  passingScore: 75,
  questions: [
    {
      id: "level-2-basics-question-1",
      question:
        "What does the bid side of Level 2 display?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Prices where traders are offering to sell",
        },
        {
          id: "b",
          label: "B",
          text:
            "Prices where market participants are willing to buy",
        },
        {
          id: "c",
          label: "C",
          text:
            "Only completed transactions",
        },
        {
          id: "d",
          label: "D",
          text:
            "The stock’s average daily volume",
        },
      ],
    },
    {
      id: "level-2-basics-question-2",
      question:
        "What does the ask side of Level 2 display?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Only hidden orders",
        },
        {
          id: "b",
          label: "B",
          text:
            "Prices where traders are willing to buy",
        },
        {
          id: "c",
          label: "C",
          text:
            "Prices where market participants are willing to sell",
        },
        {
          id: "d",
          label: "D",
          text:
            "The previous day’s closing price",
        },
      ],
    },
    {
      id: "level-2-basics-question-3",
      question:
        "Why should a trader avoid trusting one large displayed order completely?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Because displayed orders can be canceled, moved, or changed quickly",
        },
        {
          id: "b",
          label: "B",
          text:
            "Because large orders always guarantee a breakout",
        },
        {
          id: "c",
          label: "C",
          text:
            "Because Level 2 never shows prices",
        },
        {
          id: "d",
          label: "D",
          text:
            "Because large orders remove liquidity",
        },
      ],
    },
    {
      id: "level-2-basics-question-4",
      question:
        "What is the best way to use Level 2?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Use one large bid as a guaranteed buy signal",
        },
        {
          id: "b",
          label: "B",
          text:
            "Ignore price action and volume",
        },
        {
          id: "c",
          label: "C",
          text:
            "Assume every displayed order will execute",
        },
        {
          id: "d",
          label: "D",
          text:
            "Combine order changes, executions, spread, liquidity, price action, and risk management",
        },
      ],
    },
  ],
},

"trading-psychology-discipline": {
  id: "trading-psychology-discipline-quiz",
  lessonId: "trading-psychology-discipline",
  title: "Trading Psychology and Discipline Quiz",
  description:
    "Check your understanding of emotions, preparation, rule-following, revenge trading, and daily risk limits.",
  passingScore: 75,
  questions: [
    {
      id: "trading-psychology-discipline-question-1",
      question:
        "What does trading discipline mean?",
      correctAnswer: "b",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Changing the plan whenever emotions become strong",
        },
        {
          id: "b",
          label: "B",
          text:
            "Consistently following tested entry, risk, and exit rules",
        },
        {
          id: "c",
          label: "C",
          text:
            "Avoiding every losing trade",
        },
        {
          id: "d",
          label: "D",
          text:
            "Taking more trades after a loss",
        },
      ],
    },
    {
      id: "trading-psychology-discipline-question-2",
      question:
        "Which behavior is an example of greed affecting a trade?",
      correctAnswer: "c",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Following the planned position size",
        },
        {
          id: "b",
          label: "B",
          text:
            "Stopping after reaching the daily-loss limit",
        },
        {
          id: "c",
          label: "C",
          text:
            "Entering late with an oversized position because price is rising quickly",
        },
        {
          id: "d",
          label: "D",
          text:
            "Waiting for confirmation",
        },
      ],
    },
    {
      id: "trading-psychology-discipline-question-3",
      question:
        "What is revenge trading?",
      correctAnswer: "a",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Taking impulsive trades to recover a recent loss quickly",
        },
        {
          id: "b",
          label: "B",
          text:
            "Reviewing a losing trade before continuing",
        },
        {
          id: "c",
          label: "C",
          text:
            "Following the normal position size",
        },
        {
          id: "d",
          label: "D",
          text:
            "Stopping when the daily-loss limit is reached",
        },
      ],
    },
    {
      id: "trading-psychology-discipline-question-4",
      question:
        "What is a disciplined response after a losing trade?",
      correctAnswer: "d",
      answers: [
        {
          id: "a",
          label: "A",
          text:
            "Immediately double the next position",
        },
        {
          id: "b",
          label: "B",
          text:
            "Remove the stop from the next trade",
        },
        {
          id: "c",
          label: "C",
          text:
            "Take any available setup to recover the loss",
        },
        {
          id: "d",
          label: "D",
          text:
            "Pause, review the trade, and wait for the next qualified setup",
        },
      ],
    },
  ],
},

  "candlestick-basics": {
    id: "candlestick-basics-quiz",
    lessonId: "candlestick-basics",
    title: "Candlestick Basics Quiz",
    description:
      "Check your understanding of candle bodies, wicks, opening prices, closing prices, and price-action context.",
    passingScore: 75,
    questions: [
      {
        id: "candlestick-question-1",
        question:
          "What does the body of a candlestick represent?",
        correctAnswer: "b",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "Only the highest price reached during the period",
          },
          {
            id: "b",
            label: "B",
            text:
              "The distance between the opening and closing prices",
          },
          {
            id: "c",
            label: "C",
            text:
              "The total number of shares available to borrow",
          },
          {
            id: "d",
            label: "D",
            text:
              "The difference between the bid and ask",
          },
        ],
      },
      {
        id: "candlestick-question-2",
        question:
          "What do the upper and lower wicks show?",
        correctAnswer: "c",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "The company’s earnings and revenue",
          },
          {
            id: "b",
            label: "B",
            text:
              "The trader’s profit target and stop loss",
          },
          {
            id: "c",
            label: "C",
            text:
              "The highest and lowest prices reached during the period",
          },
          {
            id: "d",
            label: "D",
            text:
              "The number of market participants",
          },
        ],
      },
      {
        id: "candlestick-question-3",
        question:
          "A candle forms a long lower wick near support and closes near its high. What may this suggest?",
        correctAnswer: "a",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "Sellers pushed price lower, but buyers regained control before the close",
          },
          {
            id: "b",
            label: "B",
            text:
              "The stock is guaranteed to rise during the next candle",
          },
          {
            id: "c",
            label: "C",
            text:
              "The market has permanently removed all selling pressure",
          },
          {
            id: "d",
            label: "D",
            text:
              "The candle should always be shorted immediately",
          },
        ],
      },
      {
        id: "candlestick-question-4",
        question:
          "Why should a trader avoid using one candlestick as a complete trade signal?",
        correctAnswer: "d",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "Candlesticks only work after the market closes",
          },
          {
            id: "b",
            label: "B",
            text:
              "Candlesticks cannot display opening prices",
          },
          {
            id: "c",
            label: "C",
            text:
              "Every candlestick means exactly the same thing",
          },
          {
            id: "d",
            label: "D",
            text:
              "Trend, support, resistance, volume, VWAP, and risk also matter",
          },
        ],
      },
    ],
  },

    "support-resistance": {
    id: "support-resistance-quiz",
    lessonId: "support-resistance",
    title: "Support and Resistance Basics Quiz",
    description:
      "Check your understanding of support zones, resistance zones, breakouts, retests, confirmation, and role reversal.",
    passingScore: 75,
    questions: [
      {
        id: "support-resistance-question-1",
        question:
          "Why should support and resistance usually be treated as zones instead of exact one-cent prices?",
        correctAnswer: "b",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "Because chart prices are never accurate",
          },
          {
            id: "b",
            label: "B",
            text:
              "Because buying and selling reactions can occur across a nearby price area",
          },
          {
            id: "c",
            label: "C",
            text:
              "Because traders cannot see exact prices",
          },
          {
            id: "d",
            label: "D",
            text:
              "Because every stock moves in ten-cent increments",
          },
        ],
      },
      {
        id: "support-resistance-question-2",
        question:
          "What best describes resistance?",
        correctAnswer: "c",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "An area where buyers always guarantee a reversal",
          },
          {
            id: "b",
            label: "B",
            text:
              "The lowest price a stock can ever reach",
          },
          {
            id: "c",
            label: "C",
            text:
              "An area where selling pressure has previously slowed or stopped price from rising",
          },
          {
            id: "d",
            label: "D",
            text:
              "A price that can never be broken",
          },
        ],
      },
      {
        id: "support-resistance-question-3",
        question:
          "Which combination provides stronger confirmation of a breakout above resistance?",
        correctAnswer: "d",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "Price touches resistance for one second",
          },
          {
            id: "b",
            label: "B",
            text:
              "Price moves above resistance with declining volume and immediately falls back",
          },
          {
            id: "c",
            label: "C",
            text:
              "One trader predicts the stock will rise",
          },
          {
            id: "d",
            label: "D",
            text:
              "Price closes above resistance with stronger volume and continues holding the level",
          },
        ],
      },
      {
        id: "support-resistance-question-4",
        question:
          "What is role reversal after a confirmed breakout?",
        correctAnswer: "a",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "Previous resistance later acts as support during a pullback",
          },
          {
            id: "b",
            label: "B",
            text:
              "Support and resistance permanently disappear",
          },
          {
            id: "c",
            label: "C",
            text:
              "The stock must return to its opening price",
          },
          {
            id: "d",
            label: "D",
            text:
              "The breakout candle becomes the new stop loss automatically",
          },
        ],
      },
    ],
  },

  "macd-basics": {
    id: "macd-basics-quiz",
    lessonId: "macd-basics",
    title: "MACD: Momentum and Confirmation Quiz",
    description:
      "Check your understanding of MACD crossovers, histogram momentum, confirmation, and divergence.",
    passingScore: 70,
    questions: [
      {
        id: "macd-question-1",
        question:
          "What does a bullish MACD crossover usually mean?",
        correctAnswer: "b",
        answers: [
          {
            id: "a",
            label: "A",
            text: "The stock is guaranteed to rise",
          },
          {
            id: "b",
            label: "B",
            text:
              "The MACD line moved above the signal line",
          },
          {
            id: "c",
            label: "C",
            text: "Volume has disappeared",
          },
          {
            id: "d",
            label: "D",
            text: "The market has closed",
          },
        ],
      },
      {
        id: "macd-question-2",
        question:
          "What can shrinking MACD histogram bars indicate?",
        correctAnswer: "c",
        answers: [
          {
            id: "a",
            label: "A",
            text: "The stock cannot reverse",
          },
          {
            id: "b",
            label: "B",
            text:
              "The stock has reached its exact top",
          },
          {
            id: "c",
            label: "C",
            text: "Momentum may be weakening",
          },
          {
            id: "d",
            label: "D",
            text:
              "The spread is becoming smaller",
          },
        ],
      },
      {
        id: "macd-question-3",
        question:
          "Why should MACD not be used by itself?",
        correctAnswer: "d",
        answers: [
          {
            id: "a",
            label: "A",
            text: "MACD only works on one stock",
          },
          {
            id: "b",
            label: "B",
            text:
              "MACD always reacts before price",
          },
          {
            id: "c",
            label: "C",
            text:
              "MACD replaces the need for risk management",
          },
          {
            id: "d",
            label: "D",
            text:
              "Price structure, volume, VWAP, support, resistance, and risk still matter",
          },
        ],
      },
      {
        id: "macd-question-4",
        question:
          "What is bearish divergence?",
        correctAnswer: "a",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "Price makes higher highs while MACD makes lower highs",
          },
          {
            id: "b",
            label: "B",
            text:
              "Price and MACD both make stronger highs",
          },
          {
            id: "c",
            label: "C",
            text:
              "The stock price and volume are identical",
          },
          {
            id: "d",
            label: "D",
            text:
              "The MACD line disappears from the chart",
          },
        ],
      },
    ],
  },

  "stop-loss": {
    id: "stop-loss-quiz",
    lessonId: "stop-loss",
    title: "Stop Loss Knowledge Check",
    description:
      "Check your understanding of stop placement, risk per share, position sizing, and stop-loss discipline.",
    passingScore: 75,
    questions: [
      {
        id: "stop-loss-question-1",
        question:
          "Where should a stop loss usually be placed for a long trade?",
        correctAnswer: "b",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "At a random dollar amount below the entry",
          },
          {
            id: "b",
            label: "B",
            text:
              "Beyond the level where the trade idea becomes invalid",
          },
          {
            id: "c",
            label: "C",
            text:
              "Exactly one cent below the entry",
          },
          {
            id: "d",
            label: "D",
            text:
              "Only after the trade begins losing money",
          },
        ],
      },
      {
        id: "stop-loss-question-2",
        question:
          "A trader enters at $5.20 and places a stop at $5.10. What is the risk per share?",
        correctAnswer: "b",
        answers: [
          {
            id: "a",
            label: "A",
            text: "$0.05",
          },
          {
            id: "b",
            label: "B",
            text: "$0.10",
          },
          {
            id: "c",
            label: "C",
            text: "$0.20",
          },
          {
            id: "d",
            label: "D",
            text: "$0.30",
          },
        ],
      },
      {
        id: "stop-loss-question-3",
        question:
          "A trader is willing to risk $50 and the risk per share is $0.10. What is the position size?",
        correctAnswer: "c",
        answers: [
          {
            id: "a",
            label: "A",
            text: "50 shares",
          },
          {
            id: "b",
            label: "B",
            text: "100 shares",
          },
          {
            id: "c",
            label: "C",
            text: "500 shares",
          },
          {
            id: "d",
            label: "D",
            text: "1,000 shares",
          },
        ],
      },
      {
        id: "stop-loss-question-4",
        question:
          "What happens when a trader moves a stop farther away after the trade weakens?",
        correctAnswer: "d",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "The original risk becomes smaller",
          },
          {
            id: "b",
            label: "B",
            text:
              "The trade automatically becomes safer",
          },
          {
            id: "c",
            label: "C",
            text:
              "The target becomes guaranteed",
          },
          {
            id: "d",
            label: "D",
            text:
              "The potential loss increases beyond the original plan",
          },
        ],
      },
    ],
  },

  "short-selling": {
    id: "short-selling-quiz",
    lessonId: "short-selling",
    title: "Introduction to Short Selling Quiz",
    description:
      "Check your understanding of borrowed shares, selling short, buying to cover, borrowing costs, and short-sale risk.",
    passingScore: 75,
    questions: [
      {
        id: "short-selling-question-1",
        question:
          "What must generally happen before a trader can sell a stock short?",
        correctAnswer: "b",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "The trader must already own the shares",
          },
          {
            id: "b",
            label: "B",
            text:
              "The broker must locate shares that are available to borrow",
          },
          {
            id: "c",
            label: "C",
            text:
              "The stock must reach an all-time high",
          },
          {
            id: "d",
            label: "D",
            text:
              "The company must approve the trade",
          },
        ],
      },
      {
        id: "short-selling-question-2",
        question:
          "Which order is normally used to close a short position?",
        correctAnswer: "c",
        answers: [
          {
            id: "a",
            label: "A",
            text: "Sell to close",
          },
          {
            id: "b",
            label: "B",
            text: "Buy to open",
          },
          {
            id: "c",
            label: "C",
            text: "Buy to cover",
          },
          {
            id: "d",
            label: "D",
            text: "Sell short again",
          },
        ],
      },
      {
        id: "short-selling-question-3",
        question:
          "A trader sells 100 shares short at $10.00 and buys them back at $8.00. What is the gross profit before costs?",
        correctAnswer: "d",
        answers: [
          {
            id: "a",
            label: "A",
            text: "$20",
          },
          {
            id: "b",
            label: "B",
            text: "$50",
          },
          {
            id: "c",
            label: "C",
            text: "$100",
          },
          {
            id: "d",
            label: "D",
            text: "$200",
          },
        ],
      },
      {
        id: "short-selling-question-4",
        question:
          "Why can a short position carry greater loss risk than a regular long stock position?",
        correctAnswer: "a",
        answers: [
          {
            id: "a",
            label: "A",
            text:
              "A stock price can continue rising, so the short position has no natural maximum loss",
          },
          {
            id: "b",
            label: "B",
            text:
              "A short position cannot use any risk-management rules",
          },
          {
            id: "c",
            label: "C",
            text:
              "The trader must always hold the position for one year",
          },
          {
            id: "d",
            label: "D",
            text:
              "Short sellers cannot close a position when the market is open",
          },
        ],
      },
    ],
  },
};

export function getQuizForLesson(lessonId) {
  return QUIZZES[lessonId] || null;
}